import { Component, OnInit, input } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "onset-cloze-test-exercise-indicator",
  templateUrl: "./exercise-indicator.component.html",
  standalone: true,
  styleUrls: ["./exercise-indicator.component.scss"],
  imports: [NgClass, TranslatePipe],
})
export class ExerciseIndicatorComponent implements OnInit {
  readonly totalExercise = input(0);
  readonly currentExerciseNumber = input(0);
  readonly cTestLogo = input("");
  readonly testDone = input(false);
  readonly displayLogo = input(false);

  indicators: number[] = [];

  ngOnInit() {
    if (this.totalExercise()) {
      for (let i = 1; i <= this.totalExercise(); i++) {
        this.indicators.push(i);
      }
    }
  }
}
